/* Stickidy yeni sepet davranışı (30 Eyl 2026, v48) — açılır sepet + sepet sayfası.
   1) Area düzeltmesi: <cart-drawer-items>.onCartUpdate artık cart-drawer bölümünü çeker (önceden sepet SAYFASI işaretlemesini çekmecenin içine yazıyordu).
   2) Açılır sepet yeniden çizildikçe (ekleme/adet/kaldırma) durum geri yüklenir: açık gruplar, "Ayrıntılar", öneriler, Seçtiklerin.
   3) Öneriler: /recommendations/products.json (sepetteki ilk sticker) → sepette olmayan satıştaki stickerlar; "+ Ekle" /cart/add.js (tek adet,
      Hızlı Seçim ölçüsü ya da 4 cm) → çekmecede renderContents, sayfada bölüm yenilenir.
   4) <stk-cart-page>: adet/kaldır → /cart/change.js + bölüm + cart-icon-bubble; açılır sepetle cartUpdate yayını üzerinden eşit kalır.
   Gerçek sepet uçları dışında ağ isteği yok; veri toplanmaz. */
(function () {
  'use strict';
  if (window.__stkCart) return;
  window.__stkCart = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CART = (window.routes && routes.cart_url) || '/cart';
  var state = { open: {}, shut: {}, details: false, added: {}, recs: {} };

  function $(r, s) { return r.querySelector(s); }
  function $$(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }
  function fmt(cents, f) {
    f = f || '{{amount}} TL';
    var n = (cents || 0) / 100;
    function num(dec, th, ds) { var p = n.toFixed(dec).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (p[1] ? ds + p[1] : ''); }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return num(0, ',', '');
      if (k === 'amount_with_comma_separator') return num(2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return num(0, '.', '');
      return num(2, ',', '.');
    });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  /* 1 Eki 2026 (v51) düzeltme: PUB_SUB_EVENTS constants.js'de `const` → window'da görünmez; `window.PUB_SUB_EVENTS` hep boştu →
     sepet sayfası ne abone oluyor ne yayın yapıyordu (çekmece ↔ sayfa birbirini görmüyordu; ödeme sunucudaki gerçek sepeti alınca "farklı ürünler"). */
  function EV() { try { return typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : (window.PUB_SUB_EVENTS || null); } catch (e) { return null; } }
  function pub(src) { try { var ev = EV(); if (typeof publish === 'function' && ev) publish(ev.cartUpdate, { source: src }); } catch (e) { /* yoksay */ } }
  function refreshDrawer() { try { var di = document.querySelector('cart-drawer-items'); if (di && typeof di.onCartUpdate === 'function') di.onCartUpdate(); } catch (e) { /* yoksay */ } }
  function sectionHTML(html, sel) { var d = new DOMParser().parseFromString(html, 'text/html'); var el = d.querySelector(sel); return el ? el.innerHTML : null; }
  function bubble(sections) {
    if (!sections || !sections['cart-icon-bubble']) return;
    var b = document.getElementById('cart-icon-bubble'), h = sectionHTML(sections['cart-icon-bubble'], '.shopify-section');
    if (b && h != null) b.innerHTML = h;
  }

  /* ── 1) Area düzeltmesi ── */
  function patchDrawerItems() {
    var C = customElements.get('cart-drawer-items');
    if (!C || C.prototype.__stkc) return;
    C.prototype.__stkc = true;
    C.prototype.onCartUpdate = function () {
      fetch(CART + '?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (t) {
        var h = sectionHTML(t, '.drawer__inner'), dst = document.querySelector('#CartDrawer .drawer__inner');
        if (h != null && dst) dst.innerHTML = h;
        var cd = document.querySelector('cart-drawer');
        if (cd) cd.classList.toggle('is-empty', /drawer__inner-empty/.test(t));
      }).catch(function () { /* yoksay */ });
    };
  }
  if (window.customElements) customElements.whenDefined('cart-drawer-items').then(patchDrawerItems);
  /* Area cart.js adet/silmeyi satır NUMARASIYLA gönderir (1 Eki 2026 müşteri şikâyeti: ekran eskiyince başka satır değişiyordu).
     updateQuantity sarılır: satırın data-key'i alınır, hemen ardından giden /cart/change gövdesinde line → id (anahtar) yazılır. */
  var stkKeyFor = null;
  function patchKeyed(tag, prefix) {
    customElements.whenDefined(tag).then(function () {
      var C = customElements.get(tag); if (!C || C.prototype.__stkcKey) return;
      C.prototype.__stkcKey = true; var o = C.prototype.updateQuantity;
      if (typeof o !== 'function') return;
      C.prototype.updateQuantity = function (line, quantity, name) {
        var inp = document.getElementById(prefix + line); stkKeyFor = inp && inp.getAttribute('data-key') || null;
        try { return o.apply(this, arguments); } finally { setTimeout(function () { stkKeyFor = null; }, 0); }
      };
    });
  }
  if (window.customElements) { patchKeyed('cart-drawer-items', 'Drawer-quantity-'); patchKeyed('cart-items', 'Quantity-'); }
  (function () {
    var F = window.fetch;
    window.fetch = function (input, init) {
      try {
        var u = (typeof input === 'string' || input instanceof URL) ? String(input) : (input && input.url) || '';
        if (stkKeyFor && /\/cart\/change/.test(u) && init && typeof init.body === 'string' && init.body.charAt(0) === '{') {
          var o = JSON.parse(init.body);
          if (o.line != null && o.id == null) { o.id = stkKeyFor; delete o.line; init = Object.assign({}, init, { body: JSON.stringify(o) }); }
        }
      } catch (e) { /* yoksay */ }
      return F.call(this, input, init);
    };
  })();
  /* çekmece her açılışta sunucu sepetini tazeler (sepet sayfasında yapılan değişiklik, başka sekme, bfcache) */
  if (window.customElements) customElements.whenDefined('cart-drawer').then(function () {
    var D = customElements.get('cart-drawer'); if (!D || D.prototype.__stkcOpen || typeof D.prototype.open !== 'function') return;
    D.prototype.__stkcOpen = true; var o = D.prototype.open;
    D.prototype.open = function () { var r = o.apply(this, arguments); if (document.querySelector('stk-cart-page') || this.__stkcDirty) { this.__stkcDirty = false; refreshDrawer(); } return r; };
  });
  document.addEventListener('cart:refresh', function () { var cd = document.querySelector('cart-drawer'); if (cd) cd.__stkcDirty = true; if (cd && cd.classList.contains('active')) refreshDrawer(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshDrawer(); });

  /* ── 2) durum geri yükleme ── */
  function decorate(root) {
    if (!root) return;
    $$(root, '[data-stkc-g]').forEach(function (g) {
      var k = g.getAttribute('data-stkc-g');
      g.classList.toggle('is-open', !!state.open[k]);
      g.classList.toggle('is-shut', !!state.shut[k]);
      var t = $(g, '[data-stkc-tog]'); if (t) t.setAttribute('aria-expanded', state.shut[k] ? 'false' : 'true');
    });
    var dt = $(root, '[data-stkc-dt]'), sum = $(root, '.stkc-ft [data-stkc-sum]');
    if (dt && sum) { sum.classList.toggle('is-min', !state.details); dt.setAttribute('aria-expanded', state.details ? 'true' : 'false'); dt.firstChild.nodeValue = state.details ? 'Gizle' : 'Ayrıntılar'; }
    pick(root);
    suggest(root);
  }
  function pick(root) {
    var b = $(root, '[data-stkc-pick]'); if (!b) return;
    var d = null; try { d = JSON.parse(localStorage.getItem('stkPick.v1') || 'null'); } catch (e) { d = null; }
    var n = d && d.items ? d.items.reduce(function (s, it) { return s + (it.qty || 1); }, 0) : 0;
    b.hidden = !n; if (!n) return;
    var nEl = $(b, '[data-stkc-pick-n]'); if (nEl.textContent !== String(n)) nEl.textContent = n;
    var u = (d && d.url) || '/pages/koleksiyonlar'; if (b.getAttribute('data-url') !== u) b.setAttribute('data-url', u);
  }

  /* ── 3) öneriler ── */
  function suggest(root) {
    var box = $(root, '[data-stkc-sg]'), meta = $(root, '[data-stkc-meta]');
    if (!box || !meta) return;
    var src = meta.getAttribute('data-src'); if (!src) { box.hidden = true; return; }
    var ids = (meta.getAttribute('data-ids') || '').split(',').filter(Boolean), money = meta.getAttribute('data-money');
    var key = src + '|' + ids.join(',');
    if (box.getAttribute('data-key') === key) return;
    box.setAttribute('data-key', key);
    var paint = function (list) {
      var inCart = {}; ids.forEach(function (i) { inCart[i] = 1; });
      var cm = null; try { cm = window.stkPick && stkPick.get().cm; } catch (e) { cm = null; }
      var out = [];
      (list || []).forEach(function (p) {
        if (out.length >= 6 || inCart[String(p.id)] || !p.available) return;
        var ty = (p.type || '').trim(); if (ty && ty !== 'Stickers') return;
        var vs = (p.variants || []).filter(function (v) { return v.available; }); if (!vs.length) return;
        var want = (cm || 4) + ' x ', v = vs.filter(function (x) { return (x.title || '').indexOf(want) === 0; })[0] || vs.filter(function (x) { return (x.title || '').indexOf('4 x ') === 0; })[0] || vs[0];
        var img = p.featured_image || (p.images && p.images[0]) || ''; if (img && img.indexOf('//') === 0) img = 'https:' + img;
        var lab = v.title && v.title !== 'Default Title' ? v.title.replace(/ x \d+\s*CM/i, ' cm').replace(/CM/i, 'cm') : '';
        out.push({ vid: v.id, t: p.title, img: img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '', lab: lab, price: fmt(v.price, money) });
      });
      if (!out.length) { box.hidden = true; box.innerHTML = ''; return; }
      box.innerHTML = '<h4>Sepetine yakışanlar</h4><p>3 Al 2 Öde\'ye sayılır · her 3 üründe en ucuzu bedava</p><div class="stkc-sgr">' + out.map(function (s) {
        var done = state.added[s.vid];
        return '<div class="stkc-sgc"><span class="stkc-im">' + (s.img ? '<img src="' + esc(s.img) + '" alt="" loading="lazy">' : '') + '</span><b>' + esc(s.t) + '</b><small>' + esc(s.lab ? s.lab + ' · ' : '') + esc(s.price) + '</small>' +
          '<button type="button" class="stkc-add' + (done ? ' is-done' : '') + '" data-stkc-add="' + s.vid + '"' + (done ? ' disabled' : '') + '>' + (done ? '✓ Eklendi' : '+ Ekle') + '</button></div>';
      }).join('') + '</div>';
      box.hidden = false;
    };
    if (state.recs[src]) { paint(state.recs[src]); return; }
    fetch(ROOT + 'recommendations/products.json?product_id=' + encodeURIComponent(src) + '&limit=10&intent=related')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { state.recs[src] = j.products || []; if (box.getAttribute('data-key') === key) paint(state.recs[src]); })
      .catch(function () { box.hidden = true; });
  }
  function addVariant(btn) {
    var vid = btn.getAttribute('data-stkc-add'); if (!vid || btn.disabled) return;
    var page = btn.closest('stk-cart-page');
    btn.disabled = true; btn.textContent = '…';
    var sections = page ? [page.getAttribute('data-section'), 'cart-icon-bubble'] : ['cart-drawer', 'cart-icon-bubble', 'cart-free-delivery'];
    fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +vid, quantity: 1 }], sections: sections, sections_url: location.pathname }) })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j.status || j.errors) { btn.disabled = false; btn.textContent = 'Eklenemedi'; return; }
        state.added[vid] = true;
        if (page) { page.apply(j.sections); pub('stk-cart-page'); refreshDrawer(); return; }
        var cd = document.querySelector('cart-drawer');
        if (cd && cd.renderContents) { j.id = +vid; cd.renderContents(j); } else { location.href = CART; }
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Eklenemedi'; });
  }

  /* ── tıklamalar (çekmece + sayfa) ── */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-stkc-more],[data-stkc-tog],[data-stkc-dt],[data-stkc-add],[data-stkc-pick]');
    if (!t || !t.closest('.stk-cart')) return;
    var root = t.closest('.stk-cart');
    if (t.hasAttribute('data-stkc-more')) { state.open[t.getAttribute('data-stkc-more')] = true; decorate(root); }
    else if (t.hasAttribute('data-stkc-tog')) { var g = t.getAttribute('data-stkc-tog'); state.shut[g] = !state.shut[g]; decorate(root); }
    else if (t.hasAttribute('data-stkc-dt')) { state.details = !state.details; decorate(root); }
    else if (t.hasAttribute('data-stkc-add')) { e.preventDefault(); addVariant(t); }
    else if (t.hasAttribute('data-stkc-pick')) { location.href = t.getAttribute('data-url') || '/pages/koleksiyonlar'; }
  });

  /* çekmece yeniden çizildikçe durumu geri yükle */
  function watchDrawer() {
    var cd = document.getElementById('CartDrawer'); if (!cd || cd.__stkc) return;
    cd.__stkc = true;
    var q = 0;
    new MutationObserver(function (list) {
      var real = list.some(function (m) { return !(m.target.closest && m.target.closest('[data-stkc-sg]')); });
      if (!real || q) return;
      q = requestAnimationFrame(function () { q = 0; decorate(cd); });
    }).observe(cd, { childList: true, subtree: true });
    decorate(cd);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer); else watchDrawer();

  /* ── 4) sepet sayfası ── */
  if (window.customElements && !customElements.get('stk-cart-page')) {
    customElements.define('stk-cart-page', class extends HTMLElement {
      connectedCallback() {
        var self = this, t = 0;
        this.sid = this.getAttribute('data-section');
        this.addEventListener('change', function (e) {
          var inp = e.target; if (!inp.classList || !inp.classList.contains('quantity__input')) return;
          clearTimeout(t); t = setTimeout(function () { self.update(inp.getAttribute('data-index'), inp.value); }, 350);
        });
        this.addEventListener('click', function (e) {
          var rm = e.target.closest('[data-stkc-rm]'); if (!rm) return;
          e.preventDefault(); self.update(rm.getAttribute('data-stkc-rm'), 0);
        });
        try { var ev0 = EV(); if (typeof subscribe === 'function' && ev0) this.unsub = subscribe(ev0.cartUpdate, function (ev) { if (ev && ev.source === 'stk-cart-page') return; self.refresh(); }); } catch (e) { /* yoksay */ }
        /* ek güvenlik: diğer modüllerin cart:refresh olayı, geri/ileri önbellekten dönüş ve sekmeye geri gelme → sunucudan tazele */
        this.onRefresh = function () { self.refresh(); };
        document.addEventListener('cart:refresh', this.onRefresh);
        this.onShow = function (e) { if (!e || e.persisted) self.refresh(); };
        window.addEventListener('pageshow', this.onShow);
        this.onVis = function () { if (document.visibilityState === 'visible') self.refresh(); };
        document.addEventListener('visibilitychange', this.onVis);
        decorate(this);
      }
      disconnectedCallback() { if (this.unsub) this.unsub(); document.removeEventListener('cart:refresh', this.onRefresh); window.removeEventListener('pageshow', this.onShow); document.removeEventListener('visibilitychange', this.onVis); }
      update(line, qty) {
        var self = this, row = document.getElementById('CartItem-' + line), ov = row && row.querySelector('.loading-overlay');
        var keyEl = row && row.querySelector('[data-key]'), key = keyEl && keyEl.getAttribute('data-key');   // satır anahtarı: ekran eskise de doğru satır
        if (ov) ov.classList.remove('hidden');
        this.classList.add('is-busy');
        var cfg = typeof fetchConfig === 'function' ? fetchConfig() : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
        var body = { quantity: +qty, sections: [this.sid, 'cart-icon-bubble'], sections_url: location.pathname };
        if (key) body.id = key; else body.line = +line;
        cfg.body = JSON.stringify(body);
        fetch((window.routes && routes.cart_change_url) || ROOT + 'cart/change', cfg)
          .then(function (r) { return r.json(); })
          .then(function (st) {
            if (st.errors || st.status) {
              var er = document.getElementById('Line-item-error-' + line), inp = document.getElementById('Quantity-' + line);
              if (er) er.querySelector('.cart-item__error-text').textContent = st.errors || st.description || (window.cartStrings && cartStrings.error) || 'Güncellenemedi';
              if (inp) inp.value = inp.getAttribute('value');
              return;
            }
            self.apply(st.sections); pub('stk-cart-page'); refreshDrawer();
          })
          .catch(function () { var ce = document.getElementById('cart-errors'); if (ce) ce.textContent = (window.cartStrings && cartStrings.error) || 'Sepet güncellenemedi, sayfayı yenile.'; })
          .finally(function () { self.classList.remove('is-busy'); if (ov) ov.classList.add('hidden'); });
      }
      apply(sections) {
        if (!sections) return;
        var h = sections[this.sid] && sectionHTML(sections[this.sid], 'stk-cart-page');
        if (h != null) this.innerHTML = h;
        bubble(sections);
        decorate(this);
      }
      refresh() {
        var self = this;
        fetch(CART + '?section_id=' + encodeURIComponent(this.sid)).then(function (r) { return r.text(); }).then(function (t) { var o = {}; o[self.sid] = t; self.apply(o); }).catch(function () { /* yoksay */ });
      }
    });
  }
})();
